/* Quick-shop + quick-add handlers for custom product cards.
   Loaded once (deferred) from theme.liquid — buttons reference these via onclick.
   The quick-shop dialog is a shared shell (snippets/quick-shop-modal.liquid);
   product data is fetched from /products/{handle}.js on demand and cached. */

(function () {
  var cache = {};
  var currentProduct = null;

  function dialogEl() {
    return document.getElementById('QuickShopShared');
  }

  function rootUrl(dialog) {
    return (dialog.dataset.rootUrl || '/').replace(/\/$/, '');
  }

  function formatMoney(dialog, cents) {
    return new Intl.NumberFormat(dialog.dataset.locale || undefined, {
      style: 'currency',
      currency: dialog.dataset.currency || 'EUR',
    }).format(cents / 100);
  }

  function imageUrl(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function variantOptions(v) {
    return v.options || [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
  }

  function isColorOption(name) {
    var n = name.toLowerCase();
    return n.indexOf('farve') !== -1 || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
  }

  function selectedOptionsIn(form) {
    var selected = [];
    for (var fs of form.querySelectorAll('fieldset')) {
      var checked = fs.querySelector('.qs-radio:checked');
      if (checked) selected.push(checked.value);
    }
    return selected;
  }

  function matchVariant(product, selected) {
    return product.variants.find(function (v) {
      var opts = variantOptions(v);
      return opts.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updateSubmit(dialog, variant) {
    var btn = dialog.querySelector('.qs-submit');
    if (!variant) return;
    if (variant.available === false) {
      btn.disabled = true;
      btn.textContent = btn.dataset.textSoldout;
    } else {
      btn.disabled = false;
      btn.textContent = '';
      var parts = btn.dataset.textTemplate.split('__PRICE__');
      btn.append(parts[0], formatMoney(dialog, variant.price));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var srLabel = document.createElement('span');
        srLabel.className = 'visually-hidden';
        srLabel.textContent = btn.dataset.textRegularPrice + ' ';
        var compare = document.createElement('s');
        compare.className = 'qs-submit__compare';
        compare.textContent = formatMoney(dialog, variant.compare_at_price);
        btn.append(' ', srLabel, compare);
      }
      if (parts[1]) btn.append(parts[1]);
    }
  }

  function buildOptions(dialog, product, selectedVariant) {
    var container = dialog.querySelector('[data-qs-options]');
    container.textContent = '';
    var hasOnlyDefault = product.variants.length === 1 && product.variants[0].title === 'Default Title';
    if (hasOnlyDefault) return;
    var selectedOpts = variantOptions(selectedVariant);

    product.options.forEach(function (option, optIdx) {
      var name = option.name || option;
      var values = option.values || [];
      var fieldset = document.createElement('fieldset');
      fieldset.className = 'qs-fieldset';
      var legend = document.createElement('legend');
      legend.className = 'qs-legend';
      legend.textContent = name;
      fieldset.appendChild(legend);
      var row = document.createElement('div');
      row.className = 'qs-values';

      values.forEach(function (value, valIdx) {
        var id = 'qs-shared-' + optIdx + '-' + valIdx;
        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'qs-radio visually-hidden';
        input.id = id;
        input.name = 'qs-option-' + optIdx;
        input.value = value;
        if (selectedOpts[optIdx] === value) input.checked = true;
        row.appendChild(input);

        var label = document.createElement('label');
        label.htmlFor = id;
        if (isColorOption(name)) {
          label.className = 'qs-swatch';
          label.title = value;
          var colorHandle = value.toLowerCase().replace(/\s/g, '');
          var isNeo = colorHandle === 'neochrome' || colorHandle.indexOf('rainbow') !== -1 || colorHandle.indexOf('oil-slick') !== -1;
          var variantWithImage = product.variants.find(function (v) {
            return variantOptions(v).indexOf(value) !== -1 && v.featured_image && v.featured_image.src;
          });
          if (variantWithImage) {
            var img = document.createElement('img');
            img.className = 'qs-swatch-img';
            img.src = imageUrl(variantWithImage.featured_image.src, 80);
            img.alt = value;
            img.width = 40;
            img.height = 40;
            img.loading = 'lazy';
            label.appendChild(img);
          } else {
            var span = document.createElement('span');
            span.className = isNeo ? 'qs-swatch-color qs-swatch-color--neo' : 'qs-swatch-color';
            if (!isNeo) span.style.backgroundColor = colorHandle;
            label.appendChild(span);
          }
        } else {
          label.className = 'qs-pill';
          label.textContent = value;
        }
        row.appendChild(label);
      });

      fieldset.appendChild(row);
      container.appendChild(fieldset);
    });
  }

  function populate(dialog, product, preferredVariantId) {
    currentProduct = product;
    var selectedVariant =
      (preferredVariantId && product.variants.find(function (v) { return v.id === preferredVariantId; })) ||
      product.variants.find(function (v) { return v.available; }) ||
      product.variants[0];
    dialog.setAttribute('aria-label', product.title);
    dialog.querySelector('[data-qs-title]').textContent = product.title;
    dialog.querySelector('.qs-variant-id').value = selectedVariant ? selectedVariant.id : '';
    buildOptions(dialog, product, selectedVariant);
    updateSubmit(dialog, selectedVariant);
  }

  window.openQuickShop = function (handle, e, preferredVariantId) {
    e.preventDefault();
    e.stopPropagation();
    var dialog = dialogEl();
    if (!dialog) return;
    var ready = cache[handle]
      ? Promise.resolve(cache[handle])
      : fetch(rootUrl(dialog) + '/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('Product load failed');
            return r.json();
          })
          .then(function (p) {
            cache[handle] = p;
            return p;
          });
    ready
      .then(function (p) {
        populate(dialog, p, preferredVariantId);
        dialog.showModal();
      })
      .catch(function () {
        /* Fallback: go to the product page instead of a broken modal */
        window.location.href = rootUrl(dialog) + '/products/' + encodeURIComponent(handle);
      });
  };

  document.addEventListener('DOMContentLoaded', function () {
    var dialog = dialogEl();
    if (!dialog) return;
    var form = dialog.querySelector('.quick-add-form');
    var variantInput = dialog.querySelector('.qs-variant-id');

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    form.addEventListener('change', function (e) {
      if (!e.target.classList.contains('qs-radio') || !currentProduct) return;
      var matched = matchVariant(currentProduct, selectedOptionsIn(form));
      if (matched) variantInput.value = matched.id;
      updateSubmit(dialog, matched);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.qs-submit');
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.dataset.textAdding;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'id=' + variantInput.value + '&quantity=1'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          btn.textContent = btn.dataset.textAdded;
          /* Refresh & open cart drawer so item is visible */
          if (window.refreshCartDrawer) {
            window.refreshCartDrawer({ open: true });
          }
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
            dialog.close();
          }, 1200);
        })
        .catch(function () {
          btn.textContent = btn.dataset.textError;
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        });
    });
  });
})();

window.quickAddToCart = function (variantId, btn, e) {
  e.preventDefault();
  e.stopPropagation();
  if (btn.disabled) return;

  var originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'id=' + variantId + '&quantity=1'
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Add failed');
      return res.json();
    })
    .then(function () {
      btn.textContent = '✓';
      btn.classList.add('cpc__variant-pill--added');

      /* Update cart bubble + open refreshed drawer */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bubbles = document.querySelectorAll('.ch__cart-bubble');
          for (var i = 0; i < bubbles.length; i++) {
            bubbles[i].textContent = cart.item_count;
          }
          if (cart.item_count > 0) {
            var icons = document.querySelectorAll('.ch__icon--cart');
            for (var j = 0; j < icons.length; j++) {
              if (!icons[j].querySelector('.ch__cart-bubble')) {
                var span = document.createElement('span');
                span.className = 'ch__cart-bubble';
                span.textContent = cart.item_count;
                icons[j].appendChild(span);
              }
            }
          }
          /* Refresh & open the cart drawer so the new item is visible */
          if (window.refreshCartDrawer) {
            window.refreshCartDrawer({ open: true });
          }
        });

      /* Show toast notification */
      window.__showCartToast && window.__showCartToast(btn.closest('.cpc')?.querySelector('.cpc__title')?.textContent?.trim());

      /* Reset pill after 1.5s */
      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('cpc__variant-pill--added');
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.textContent = btn.dataset.errorText || '✕';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
};

/* Colour swatches on product cards: hover previews a colour, click selects it.
   Swaps the card image, price, links and add-to-cart variant in place — no reload.
   Per-colour data is carried on each .cpc__swatch button's data-* attributes. */
(function () {
  function cardOf(el) { return el.closest ? el.closest('.cpc') : null; }
  function rowOf(card) { return card ? card.querySelector('.cpc__swatches') : null; }

  function selectedSwatch(card) {
    var row = rowOf(card);
    if (!row) return null;
    return (
      row.querySelector('.cpc__swatch[data-cpc-selected]') ||
      row.querySelector('.cpc__swatch.is-active') ||
      row.querySelector('.cpc__swatch')
    );
  }

  function markActive(row, sw) {
    if (!row) return;
    var all = row.querySelectorAll('.cpc__swatch');
    for (var i = 0; i < all.length; i++) {
      var on = all[i] === sw;
      all[i].classList.toggle('is-active', on);
      all[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function apply(card, sw) {
    if (!card || !sw) return;
    var d = sw.dataset;

    var img = card.querySelector('.cpc__image--primary');
    if (img && d.image) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = d.image;
    }

    var prices = card.querySelector('.cpc__prices');
    if (prices && d.price) {
      prices.textContent = '';
      var onSale = d.onSale === 'true';
      var price = document.createElement('span');
      price.className = onSale ? 'cpc__price cpc__price--sale' : 'cpc__price';
      price.textContent = d.price;
      prices.appendChild(price);
      if (onSale && d.compare) {
        var compare = document.createElement('span');
        compare.className = 'cpc__price cpc__price--compare';
        compare.textContent = d.compare;
        prices.appendChild(compare);
      }
    }

    /* Keep the image sale badge in sync with the shown colour — hide it for
       full-price colours, and show the right percentage for sale colours. */
    var saleBadge = card.querySelector('.cpc__badge--sale');
    if (saleBadge) {
      var badgeOn = d.onSale === 'true' && d.discountPct;
      saleBadge.hidden = !badgeOn;
      if (badgeOn && saleBadge.dataset.saveTemplate) {
        saleBadge.textContent = saleBadge.dataset.saveTemplate.replace('[PCT]', d.discountPct);
      }
    }

    if (d.url) {
      var links = card.querySelectorAll('.cpc__link, .cpc__media-link');
      for (var i = 0; i < links.length; i++) links[i].setAttribute('href', d.url);
    }

    if (d.variantId) {
      var single = card.querySelector('.cpc__add-single:not(.cpc__add-single--options)');
      if (single) {
        single.setAttribute('data-variant-id', d.variantId);
        single.setAttribute('onclick', "quickAddToCart('" + d.variantId + "', this, event)");
      }
      /* Re-point quick-shop buttons at the selected colour without parsing money. */
      var qs = card.querySelectorAll('.cpc__add-single--options, .cpc__quick-add-mobile');
      for (var j = 0; j < qs.length; j++) {
        var oc = qs[j].getAttribute('onclick') || '';
        var m = oc.match(/openQuickShop\('([^']+)'/);
        if (m) qs[j].setAttribute('onclick', "openQuickShop('" + m[1] + "', event, " + d.variantId + ')');
      }
    }
  }

  /* pointerenter/leave don't bubble — use the capture phase for delegation. */
  document.addEventListener('pointerenter', function (e) {
    var sw = e.target.closest && e.target.closest('.cpc__swatch');
    if (!sw) return;
    var card = cardOf(sw);
    if (!card) return;
    apply(card, sw);
    markActive(rowOf(card), sw);
  }, true);

  document.addEventListener('pointerleave', function (e) {
    var row = e.target.closest && e.target.closest('.cpc__swatches');
    if (!row) return;
    var card = cardOf(row);
    if (!card) return;
    var sel = selectedSwatch(card);
    apply(card, sel);
    markActive(row, sel);
  }, true);

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.cpc__swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    var card = cardOf(sw);
    if (!card) return;
    var row = rowOf(card);
    var prev = row.querySelector('.cpc__swatch[data-cpc-selected]');
    if (prev) prev.removeAttribute('data-cpc-selected');
    sw.setAttribute('data-cpc-selected', '');
    apply(card, sw);
    markActive(row, sw);
  });
})();
